import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.591 3.532a2.25 2.25 0 0 0-3.182 0L6.172 13.77c-.308.309-.52.7-.61 1.127l-.901 4.269a.75.75 0 0 0 .889.888l4.268-.9a2.25 2.25 0 0 0 1.127-.61L21.182 8.304a2.25 2.25 0 0 0 0-3.182zm-2.121 1.06a.75.75 0 0 1 1.06 0l1.591 1.592a.75.75 0 0 1 0 1.06l-1.396 1.397-2.652-2.652zM15.013 7.05l-7.78 7.78a.75.75 0 0 0-.204.375l-.663 3.143 3.143-.663a.75.75 0 0 0 .375-.203l7.78-7.78z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }